import React from 'react';
export function Footer() {
  return <footer className="w-full bg-black border-t border-[#00B4D8]/20 py-10 px-4" data-id="element-105">
      <div className="max-w-3xl mx-auto text-center" data-id="element-106">
        <div className="text-[#00B4D8] text-2xl font-black tracking-widest mb-4" data-id="element-107">
          🎾 PROFEPACK™
        </div>
        <p className="text-gray-400 text-sm leading-relaxed mb-4 max-w-xl mx-auto" data-id="element-108">
          El sistema de clases N°1 para profesores de tenis en Argentina.
        </p>
        <p className="text-gray-400 text-sm italic mb-6" data-id="element-109">
          Porque enseñar tenis no debería costarte todas las noches de la
          semana.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 text-sm text-gray-300 mb-6" data-id="element-110">
          <span data-id="element-111">📧 soporteprofepack@gmail.com</span>
          <span className="hidden sm:inline" data-id="element-112">•</span>
          <span data-id="element-113">📲 @profepack</span>
          <span className="hidden sm:inline" data-id="element-114">•</span>
          <span data-id="element-115">🌐 www.profepack.com</span>
        </div>

        <div className="h-px bg-[#00B4D8]/20 mb-6" data-id="element-116" />
        <p className="text-gray-400 text-xs mb-2" data-id="element-117">
          © ProfePack™ 2025 — Todos los derechos reservados.
        </p>
        <p className="text-gray-500 text-xs mb-6" data-id="element-118">
          Prohibida la reproducción y redistribución sin autorización expresa.
        </p>
      </div>
    </footer>;
}